import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Logotypy = {
	name: NAME,
	apiProvider,
	router,
};
